/**
 * "Your Privacy Choices" 弹窗（snippets/privacy-choices-popup.liquid）。
 * 开关 + Save Preferences：通过 Shopify Customer Privacy API 设置 sale_of_data（本浏览器生效），opt-out 时同时关闭 marketing，
 * 并让 Consentmo 关闭 Marketing 类别（同时生成一条 Consentmo 同意记录作为日志）。
 * "是否已拒绝出售/共享"统一由 snippets/privacy-sale-optout.liquid 的 window.JoyinPrivacy 判断；GPC 时开关固定开启。
 */
(function () {
  'use strict';

  var popup = document.getElementById('privacy-choices-popup');
  var privacy = window.JoyinPrivacy;
  if (!popup || !privacy) { return; }

  var toggle = popup.querySelector('#privacy-choices-toggle');
  var gpcNotice = popup.querySelector('[data-privacy-gpc]');
  var errorMessage = popup.querySelector('[data-privacy-error]');
  var saveButton = popup.querySelector('[data-privacy-save]');
  var closeButton = popup.querySelector('.halo-popup-close');
  var overlay = document.querySelector('.background-overlay');
  var lastFocused = null;

  function syncState() {
    var gpc = navigator.globalPrivacyControl === true;
    toggle.checked = privacy.saleDenied();
    toggle.disabled = gpc;
    gpcNotice.hidden = !gpc;
    errorMessage.hidden = true;
  }

  function onKeydown(event) {
    if (event.key === 'Escape') { closePopup(); }
  }

  // 读到当前偏好后再打开：避免访客在加载期间的操作被同步覆盖、或按默认未勾选状态把已拒绝的访客改回允许；
  // 主题 trapFocus 只在建立时收集可聚焦元素，也须在按钮状态确定后调用。API 通常已由 theme.liquid 加载，此时同步回调。
  function openPopup(trigger) {
    lastFocused = trigger;
    privacy.loadApi(function () {
      syncState();
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('privacy-choices-show');
      trapFocus(popup, closeButton);
      document.addEventListener('keydown', onKeydown);
    });
  }

  function closePopup() {
    document.removeEventListener('keydown', onKeydown);
    document.body.classList.remove('privacy-choices-show');
    popup.setAttribute('aria-hidden', 'true');
    removeTrapFocus(lastFocused);
  }

  // 等下一次 Shopify 同意写入完成（visitorConsentCollected），最多等 timeout 毫秒
  function waitForConsentWrite(timeout) {
    return new Promise(function (resolve) {
      var timer = setTimeout(done, timeout);
      function done() {
        clearTimeout(timer);
        document.removeEventListener('visitorConsentCollected', done);
        resolve();
      }
      document.addEventListener('visitorConsentCollected', done);
    });
  }

  // 先让 Consentmo 关闭 Marketing 并等它写完 Shopify 同意，再写 sale_of_data。只保证调用顺序不够：
  // Consentmo 的 setTrackingConsent 在它内部写 Shopify 同意之前就 resolve，而那次写入带着调用时的旧 sale_of_data，
  // 若比我们的写入后落地，会把 opt-out 覆盖回允许（2026-10 在 joiedomi 实测复现）。
  // 每次都调用（即使 Marketing 已关闭）：Consentmo 会为此生成一条同意记录（Analytics & Reports → Consent records），
  // 含 customer_id（已登录顾客）、IP/地区、blocked_cookies、时间，作为 opt-out 日志。
  // 统计/偏好沿用访客已有的选择；从未选择过的视为未同意（只传 marketing 时 Consentmo 会把它们记为已同意）。
  function disableConsentmoMarketing() {
    try {
      var c = window.Consentmo;
      if (c && typeof c.setTrackingConsent === 'function') {
        var current = window.Shopify.customerPrivacy.currentVisitorConsent();
        var written = waitForConsentWrite(3000); // 先挂监听：事件可能在 Consentmo 的 Promise resolve 之前触发
        return Promise.resolve(c.setTrackingConsent({
          analytics: current.analytics === 'yes',
          preferences: current.preferences === 'yes',
          marketing: false
        })).catch(function () {}).then(function () { return written; });
      }
    } catch (e) {}
    return Promise.resolve();
  }

  function save(optOut, done) {
    privacy.loadApi(function (error) {
      if (error) { return done(error); }
      var before = optOut ? disableConsentmoMarketing() : Promise.resolve();
      before.then(function () {
        var consent = optOut ? { sale_of_data: false, marketing: false } : { sale_of_data: true };
        window.Shopify.customerPrivacy.setTrackingConsent(consent, function (result) {
          done(result && result.error ? result.error : null);
        });
      });
    });
  }

  saveButton.addEventListener('click', function () {
    var optOut = toggle.checked;
    if (optOut === privacy.saleDenied()) { return closePopup(); }

    saveButton.disabled = true;
    errorMessage.hidden = true;
    save(optOut, function (error) {
      saveButton.disabled = false;
      if (error) {
        console.warn('[privacy-choices] setTrackingConsent failed:', error);
        errorMessage.hidden = false;
        return;
      }
      privacy.apply(); // 刷新拦截器并推送 Consent Mode，当前页面立即生效
      if (optOut && typeof window.fbq === 'function') { window.fbq('dataProcessingOptions', ['LDU'], 0, 0); }
      closePopup();
    });
  });

  // 委托到 document：主题编辑器重新渲染页脚后入口依然有效
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-privacy-open]');
    if (trigger) { openPopup(trigger); }
  });

  popup.querySelectorAll('[data-privacy-close]').forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      if (document.body.classList.contains('privacy-choices-show')) { closePopup(); }
    });
  }
})();
